<template>
  <div id="myaccount">
    <div class="rechage_wrapper">
      <div class="header_wrapper">
        <div class="header_info">
          <el-row>
            <el-col :span="2">
              <div class="portrait">
                <!-- <el-avatar src="../assets/img/portrait.png" :size="100"></el-avatar> -->
                <img width="80px" src="../assets/img/portrait.png" >
              </div>
            </el-col>
            <el-col :span="22">
              <div class="header_right content-flex">
                <p class="center-nickname">您好,金牛证券会员</p>
                <i class="line"></i>
                <p class="last-time">用户名： {{ phone }} |  上次登陆时间：{{ time }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="recharge_content">
        <ul class="recharge_right">
        <div class="common_bg">
          <li @click="changeAccount(1)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==1 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/rechange"><i class="el-icon-user" style="margin-right: 9px;"></i>我的账户</router-link>
          </li>
          <li @click="changeAccount(9)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==9 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/account_info"><i class="el-icon-s-order" style="margin-right: 9px;"></i>证券资产 </router-link>
          </li>
          <li v-if="lifetimeRewardStatus == 1" @click="changeAccount(17)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==17 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/lifetime_reward"><i class="el-icon-medal" style="margin-right: 9px;"></i>终生奖励</router-link>
          </li>

          <li  v-if="stablebaoStatus == 1" @click="changeAccount(18)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType == 18 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/stable_coinbao"><i class="el-icon-suitcase" style="margin-right: 9px;"></i>稳定币基金 <span style="color:#D02E27;line-height:-10px;font-size: 10px;"></span></router-link>
          </li>


          <li v-if="vipRewardTradeStatus == 1" @click="changeAccount(10)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==10 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/vip_reward"><i class="el-icon-s-management" style="margin-right: 9px;"></i>VIP奖励</router-link>
          </li>
          <li v-if="timebaoStatus == 1" @click="changeAccount(15)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType == 15 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/timebao"><i class="el-icon-suitcase" style="margin-right: 9px;"></i>时时宝 <span style="color:#D02E27;margin-top: -200px !important;font-size:10px;">年化 {{timebao_annualized_rate}} % </span></router-link>
          </li>
          <li v-if="gxpayStatus == 1" @click="changeAccount(16)" style="text-align:left;padding-left: 25px;cursor: pointer;" :class="$store.state.accountType ==16 ? 'recharge_li_active' : '' ">
            <i class="el-icon-money" style="margin-right: 9px;"/>GXPAY <span style="color:#D02E27;font-size: 10px;">数字货币交易</span>
          </li>
          <li v-if="central_ucenter_transfer_status == 1" @click="changeAccount(19)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==19 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/platform_transfer"><i class="el-icon-guide" style="margin-right: 9px;"></i>资金划转</router-link>
          </li>
        </div>
          <!-- voucher -->
          <div class="common_bg">

          <li @click="changeAccount(12)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==12 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/agency"><i class="el-icon-thumb" style="margin-right: 9px;"></i>推广账户</router-link>
          </li>
          <li @click="changeAccount(7)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType == 7 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/friend_coupon"><i class="el-icon-bank-card" style="margin-right: 9px;"></i>好友现金券</router-link>
          </li>
          <li @click="changeAccount(8)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType == 8 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/usercoupon"><i class="el-icon-postcard" style="margin-right: 9px;"></i>我的现金券</router-link>
          </li>
          </div>
          <div class="common_bg">

          <li @click="changeAccount(2)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==2 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/risk_control">
              
              <!-- red dot on icon -->
              <el-badge
                v-if="unread_risk_count > 0"
                is-dot
                class="risk-badge"
              >
                <i class="el-icon-warning" style="margin-right: 9px;"></i>
              </el-badge>

              <i
                v-else
                class="el-icon-warning"
                style="margin-right: 9px;"
              ></i>

              风控通知

              <!-- text count -->
              <span v-if="unread_risk_count > 0" style="color:#D02E27;font-size: 10px;margin-left: -8px;">
                （{{ unread_risk_count }}条通知）
              </span>

            </router-link>
          </li>
          <li @click="changeAccount(11)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==11 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/information"><i class="el-icon-setting" style="margin-right: 9px;"></i>完善资料</router-link>
          </li>
          </div>
          <div class="common_bg">
          <li @click="changeAccount(3)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==3 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/strategynow"><i class="el-icon-s-data" style="margin-right: 9px;"/>配资账户</router-link>
          </li>
          <li @click="changeAccount(4)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==4 ? 'recharge_li_active' : '' ">
            <router-link to="/stockdetailed?symbol=sz000001&direction=0"><i class="el-icon-s-marketing" style="margin-right: 9px;"/>做多交易</router-link>
          </li>
          <li  v-if="is_short_trading_enable == 1" @click="changeAccount(15)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==15 ? 'recharge_li_active' : '' ">
            <router-link to="/stockdetailed?symbol=sz000001&direction=1"><i class="el-icon-s-marketing" style="margin-right: 9px;"/>做空交易</router-link>
          </li>
          <li @click="changeAccount(6)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==6 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/trading_query"><i class="el-icon-s-claim" style="margin-right: 9px;"></i>交易查询</router-link>
          </li>
          </div>
          <div class="common_bg">
          <li @click="changeAccount(5)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType ==5 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/capital"><i class="el-icon-wallet" style="margin-right: 9px;"></i>资金操作</router-link>
          </li>
          <li v-if="financeStatus == 1" @click="changeAccount(13)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType == 13 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/finance_fund"><i class="el-icon-files" style="margin-right: 9px;"></i>定期宝</router-link>
          </li>
          <li v-if="holidayStatus == 1" @click="changeAccount(14)" style="text-align:left;padding-left: 25px;" :class="$store.state.accountType == 14 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/holiday_fund"><i class="el-icon-news" style="margin-right: 9px;"></i>节日宝</router-link>
          </li>
         
          <li style="text-align:left;padding-left: 25px;"><i class="el-icon-suitcase-1" style="margin-right: 9px;"></i>版本号 : {{ version }}</li>
          </div>
          
<!--          <li @click="changeAccount(12)" :class="$store.state.accountType == 12 ? 'recharge_li_active' : '' ">-->
<!--            <router-link to="/myaccount/friend_coupon"><i class="el-icon-suitcase"></i>好友现金券</router-link>-->
<!--          </li>-->
<!--          <li @click="changeAccount(13)" :class="$store.state.accountType == 13 ? 'recharge_li_active' : '' ">-->
<!--            <router-link to="/myaccount/usercoupon"><i class="el-icon-suitcase"></i>我的现金券</router-link>-->
<!--          </li>-->
        </ul>
          <router-view name="kids"></router-view>
      </div>
    </div>
    <keep-alive>
    </keep-alive>
  </div>
</template>
<script>
import { version } from './../../package.json'
import "./../assets/css/account.css";
import "./../assets/css/deal.css";
import './../assets/css/color.css';

export default {
  name: "Myaccount",
  data(){
    return{
      version: version,
      phone:'',
      timebaoStatus:0,
      financeStatus:0,
      holidayStatus:0, 
      vipRewardTradeStatus:0,
      lifetimeRewardStatus:0,
      gxpayStatus: 0,
      time:'',
      stable_coinbao_annualized_interest_rate:0,
      timebao_annualized_rate:0,
      is_short_trading_enable:0,
      stablebaoStatus:0,
      central_ucenter_transfer_status:0,
    }
  },
  computed: {
    unread_risk_count() {
      return this.$store.state.risk_unread_count || 0;
    }
  },
  components: {
  },
  mounted() {
    this.isLogin();
    this.getUserinfo();
    this.fetch_is_short_trading_enable();
    this.getSysConfig();
    this.getCentralTransferStatus();
  },
  methods: {
        getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebaoStatus = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getCentralTransferStatus() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "central_ucenter_transfer_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.central_ucenter_transfer_status = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    isLogin(){
      if (!this.$store.state.loginType){
        this.$router.push({
          path: "/login"
        });
      }
    },
    changeAccount(type) {
      window.sessionStorage.setItem("accountType", type);
      this.$store.state.accountType = type;

      if(type == 16){
       let that = this;
       that
         .$http({
           url: "/",
           method: "POST",
           data: {
             nozzle: "gxpay_thirdparty_digital_currency",
             token: sessionStorage.getItem("token"),
           },
         })
         .then((ret) => {
           let resData = ret.data;
           if (resData.code == 1) {
            if(resData.data.user == true){
              this.$router.push("/myaccount/gxpay");
 
            }
           else{
           this.$store.state.accountType = 1;
           window.open(resData.data.homeUrl,'_blank');
           }

           }
         });
      
      }
      else if(type == 12) {
        window.location.reload();
        this.$router.push({
          path: "/myaccount/agency"
        });
      }
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.phone = res.data.data.phone;
            that.time = res.data.data.time;
            that.timebaoStatus = res.data.data.timebao_status;
            that.financeStatus = res.data.data.finance_status;
            that.holidayStatus = res.data.data.holiday_status;
            that.vipRewardTradeStatus = res.data.data.vipRewardTradeStatus;
            that.lifetimeRewardStatus = res.data.data.lifetime_reward;
            that.gxpayStatus = res.data.data.gxpaymenu_status;
            that.stable_coinbao_annualized_interest_rate=res.data.data.stable_coinbao_annualized_interest_rate;
            that.timebao_annualized_rate=res.data.data.timebao_annualized_rate;
            that.$store.commit("setRiskUnreadCount", res.data.data.unreadRiskCount || 0);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    fetch_is_short_trading_enable() {
      let that = this;
      that.$http({
        url: "/",
        method: "POST",
        data: {
          nozzle: 'sysconfig',
          name: 'is_short_trading_enable'
        }
      })
        .then(ret => {
          let resData = ret.data;
          console.log(resData)
          if (resData.code === 1) {
            that.is_short_trading_enable = resData.data;
          }
        });
    },
  }
};
</script>
<style scoped>
@import url("./../assets/css/color.css");
@import url("./../assets/css/account.css");

*{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
  .header_wrapper{
    height: 100px;
    width: 100%;
    background-color: #d02e27;
    margin-bottom: 10px;
  }
  .header_info{
    min-width: 1000px;
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
  }
  .portrait{
    margin-top: 10px;
  }
  .header_right{
    color: white;
    height: 100px;
  }
  .line{
    display: block;
    width: 100%;
    height: 1px;
    background: url(../assets/img/line.png) no-repeat;
  }
  .center-nickname{
    font-size: 18px;
    padding-bottom: 10px;
  }
  .last-time{
    padding-top: 10px;
    font-size: 14px;
  }
  .content-flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
.recharge_right{
  margin-top:10px;
  margin-left:10px;
}

.common_bg {
  border: 1px solid #EBEEF5;
  border-radius: 10px;
  margin-bottom:15px;
}



.recharge_right > div > li {
  width: 100% !important;
  box-sizing: border-box !important;
  font-size: 15px !important;
  line-height: 45px !important;
  /* padding: 0 !important; */
  /*text-indent: 56px;*/
  text-align: left !important;
}
.recharge_right > div > li > a {
  color: #333 !important;
  display: block !important;
}
>>>.el-badge__content.is-dot {
  margin-top: 5px !important;
  margin-right: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/myaccount.vue